import React from 'react';
import { Search } from 'lucide-react';

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  placeholder?: string;
  className?: string;
  iconPosition?: 'left' | 'right';
  showIcon?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  setSearchTerm,
  placeholder = "Search...",
  className = "",
  iconPosition = 'left',
  showIcon = true
}) => {
  return (
    <div className={`relative ${className}`}>
      {showIcon && iconPosition === 'left' && (
        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
      )}
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={`w-full py-1 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 ${
          showIcon && iconPosition === 'left' ? 'pl-7' : 'pl-2.5'
        } ${showIcon && iconPosition === 'right' ? 'pr-7' : 'pr-2.5'}`}
      />
      {showIcon && iconPosition === 'right' && (
        <Search className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
      )}
    </div>
  );
};

export default SearchBar;
